module.exports = __webpack_public_path__ + "static/media/Max_Bet@3x.d04f11c9.png";